// THE OPT-IN PANE PIN — how `root._slotPinned` follows its pane (Nika
// 2026-10-10: "Yes, opt-in pin"). The pin names a PageSlot pane
// ('_canvasSlot' | '_canvasSlotSecond'); the shell's openAppPage opens a
// navbar/launcher pick beside it instead of over it. A pin belongs to a pane
// that shows something: when its pane leaves, it leaves with it; when the
// left pane leaves and the right one moves into its place (close with
// promotion, minimise), a pin on the right pane moves left with it. Pure —
// PageSlot writes the answers in the same update as the pane change.

// The pin after the LEFT (primary) pane leaves and a right pane, if any, takes
// its place.
export const slotPinAfterPrimaryLeaves = (root) =>
  root && root._slotPinned === '_canvasSlotSecond' && root._canvasSlotSecond ? '_canvasSlot' : null

// The pin after the RIGHT (second) pane leaves: its own pin dies, a left pin
// stays.
export const slotPinAfterSecondLeaves = (root) =>
  root && root._slotPinned === '_canvasSlot' ? '_canvasSlot' : null

// The header toggle: pin `key` when it shows something, unpin it when it is
// the pinned pane. One pin at a time; an unknown key changes nothing.
export const slotPinToggle = (root, key) => {
  const now = (root && root._slotPinned) || null
  if (key !== '_canvasSlot' && key !== '_canvasSlotSecond') return now
  if (now === key) return null
  return root && root[key] ? key : now
}
